module.exports = __webpack_public_path__ + "fd5a608a/img/80000000-4.a6798164.png";